import { DashboardWidget } from 'features/widget/types'
import { AnnotatedMetricResult } from 'schemas/AnnotatedMetricResultSchema'
import { ServiceResultEntry } from 'schemas/ServiceResultEntrySchema'

const resolveServiceResultEntryMap = (searchResult: DashboardWidget<AnnotatedMetricResult>) => {
  const serviceResultEntryMap = new Map<number, ServiceResultEntry[]>()

  searchResult.data.forEach((dashboardWidgetData) => {
    const topicId = dashboardWidgetData!.results![0]!.service!.parameters!.topicIds![0]!
    if (!serviceResultEntryMap.has(topicId)) {
      serviceResultEntryMap.set(topicId, [])
    }
    serviceResultEntryMap.get(topicId)!.push(dashboardWidgetData!.results![0]!)
  })

  return serviceResultEntryMap
}

export default resolveServiceResultEntryMap
